import Router from '@/router'
import { requestTsp } from './mockTsp'
import { RequestDataParams } from '#/bridge'

export default {
  appBrand: 10,
  userInfo: {
    isCarOwner: true,
    username: '18516280393',
    email: '940982164269432833@u.com',
    phone: '18516280393',
    mobilePhone: '18516280393',
    nickName: '木纹',
    userPicture: 'http://haval-sso.haval.com.cn/avatar/7fb34b13679f4e57974517c3ce3a322e',
    sex: 'MALE',
    userId: 'U940982164269432832',
    beanId: '2996741404204990464',
    accessToken:
      'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJqd3RUeXBlIjoxLCJrZXkiOiJiZWFuLWFwcC11c2VyLWtleSIsInJvbGVDb2RlIjoiYWRtaW4iLCJpYXQiOjE3MjYwMTc3NDgsImd3bUJyYW5kIjoiQ0NHMDAxIiwiYmVhbklkIjoiMzE1MDcyMjcyOTE3MzgxOTM5MiIsImp3dF90eXBlIjoxLCJjaGFubmVsIjoiQ0YwRjA0QUQtNTc0Ni00QzlELTk0RUMtNTU2OTZFQUI5NjI5Iiwic3NvSWQiOiJVMTA5MTM1NDU1MTg5NTg4Mzc3NiIsImV4cCI6MTcyNjYyMjU0OCwiZ3dtUnMiOiIyIiwiaXNzIjoiZ3d0IFNlcnZlciIsImd3SWQiOiIzMTUwNzIyNzI5MTczODE5MzkyIn0.YWVYhpNpX3DHwCSnOPttzmZFZXON74IK4o8MftkOZbjw0ThZjtYyBGR6bXC2Vj8yV6QM4Ce6CV_NbUIG9ZoLXwx1Hz0kDdmrnYfg6bpckmatXJonJzKocZAnnEOkqxkqGzQhMx_W00ndCASHsNNhaaQcPYsTgE-TfOH_TjhLEgV42KjB7wANmLmgOZs_QeUeBCifAkeLnEmbB8FKt2tOSUM5nLg9T83y7urc4nrjjHtz0g9Nj5wPIElBZx1YHbloZYjUuzp-6qRaFDZiXwq1gWyGUFfAuk18orD2idNVe2CcRppbUxCZgkLm3jkP1ziR9BTegVuo_h0Bh0j7slxI4w',
    ssoToken: 'b448a25a42f54fa78fc9806310e57d1c',
    ptToken: 'd72de9aa27fe121a81459d3957a31280',
    ssoId: 'U940982164269432832',
    gToken:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYmYiOjE3MjQ2NTU3NDIsInNvdXJjZUFwcCI6IkdXTSIsInNvdXJjZVR5cGUiOiJBTkRST0lEIiwiYXBwSWQiOiJHV00tQVBQLUFORFJPSUQtVEVTVC0xMDAwMTgiLCJwdFRva2VuIjoiZDcyZGU5YWEyN2ZlMTIxYTgxNDU5ZDM5NTdhMzEyODAiLCJleHAiOjE3MjUyNjA1NDIsImlhdCI6MTcyNDY1NTc0MiwidXNlcklkIjoiVTk0MDk4MjE2NDI2OTQzMjgzMiIsImRldmljZUlkIjoiZmJjNjhiOTBkYTU1NGUyMTllOGY5NGZhOWYwZGMyNDgifQ.qVzx8C6z38ZCF5FR1XRx3RuL3xIB4fn3Pvh1UNrNaSA',
    tokenId: '857f3021fd634df98968f966cb71e9f6',
  },
  locationInfo: {
    longitude: 22,
    latitude: 22,
    city: '北京',
    province: '北京市',
    district: '亦庄开发区',
    street: '亦城时代',
    number: '111',
    adCode: '1111',
  },
  carInfo: {
    beantechToken:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJnd21CcmFuZCI6IkNDRzAwMSIsImtleSI6ImJlYW4tYXBwLXVzZXIta2V5Iiwiand0X3R5cGUiOjEsImp3dFR5cGUiOjEsImJlYW5JZCI6IjI5OTY3NDE0MDQyMDQ5OTA0NjQiLCJjaGFubmVsIjoiZmJjNjhiOTBkYTU1NGUyMTllOGY5NGZhOWYwZGMyNDgiLCJpYXQiOjE3MjQ2NTU3NDMsImlzcyI6Imd3dCBTZXJ2ZXIiLCJnd21ScyI6IjIiLCJleHAiOjE3MjUyNjA1NDMsInNzb0lkIjoiVTk0MDk4MjE2NDI2OTQzMjgzMiIsImd3SWQiOiIyOTk2NzQxNDA0MjA0OTkwNDY0Iiwicm9sZUNvZGUiOiJhZG1pbiJ9.5xUpeuBQmUgUFbCS49khHw_AA5RvnMZibyk8F_rOWHotvnmdLCL3i2G7IsYMMAkN-GoTiSVDB9rrytahRjbzluRPfLju-TLaeM1o4Pv50-FJ0TUwU0sxHbAGAwGxaQsEWY9PY59IC8RqcC2VCMsUHE2KyNETnJyocSWyR4INN-msoyDy-e85Nx7xA0H4-nX8b-HY_D0I1oqfwvNyUeFtKugw96vnl-A0cqbT1rneBWUqAio4SlG0goLn8rob-X8YnpNm9SmRGELqRNabK04nBs6LW0dhGUpmqahNUPpQX2HweINhdLTNADBuvEX5HHe_2DHkRPgUuYHJDliC-aoDHw',
    ssoToken: 'b448a25a42f54fa78fc9806310e57d1c',
    navinfoToken: '857f3021fd634df98968f966cb71e9f6',
    vin: 'LGWVEPKR6S3257385',
    canSignalType: '',
    styleName: '高配-黑',
    modelName: '巡航CCS001',
    belongPlatform: 'gtsp',
    vtype: '巡航CCS001',
    originalVTypeName: 'CCTESTMC01A0002',
    licenseNumber: '',
    brandName: '灵魂',
    ownership: '0',
  },
  getStatusBarHeight: '24',
  pushView: (data: { page: string; hiddenNav: boolean }) => {
    let url = data.page
    if (/^http(s)?/gi.test(url)) {
      url = url.replace(window.location.origin, '')
      url = url.replace(/^#/, '')
    }
    Router.push(url)

    return {}
  },
  pushViewGwm: (data: { page: string; hiddenNav: boolean }) => {
    let url = data.page
    if (/^http(s)?/gi.test(url)) {
      url = url.replace(window.location.origin, '')
      url = url.replace(/^#/, '')
    }
    Router.push(url)

    return {}
  },
  pushNativeGwm: (data: { url: string }) => {
    let url = data.url
    if (/^http(s)?/gi.test(url)) {
      url = url.replace(window.location.origin, '')
      url = url.replace(/^#/, '')
    }
    Router.push(url)

    return {}
  },
  popView: () => {
    window.history.back()

    return {}
  },
  closeView: () => {
    window.history.back()

    return {}
  },
  requestData: (config: RequestDataParams) => {
    return requestTsp(config)
  },
}
